import broadcastMutations from '@/mass/vuex/mutations/broadcast';
import mpgroupMutations from '@/mass/vuex/mutations/mpgroup';

export default {
  ...broadcastMutations,
  ...mpgroupMutations,
};
